import { Component, OnInit } from '@angular/core';
declare var $: any;

@Component({
  selector: 'vt-login-layout',
  template: `
    <router-outlet></router-outlet>
  `,
  styles: []
})
export class LoginLayoutComponent {
  ngAfterViewInit() {
      $('body').addClass('body-login');
    }
}